import React, { useCallback, useState } from 'react'
import {
  FormDataset,
  Dataset,
  mapToDataset,
  DatasetDesigner,
} from '@confluent-cfet-medusa/dataset-designer'
import { DatasetConfig } from '../../types'

interface DatasetDesignerWrapperProps {
  setDatasetConfig: React.Dispatch<React.SetStateAction<DatasetConfig>>
  datasetDesignerFormData: FormDataset
  setDatasetDesignerFormData: React.Dispatch<React.SetStateAction<FormDataset>>
}

const DatasetDesignerWrapper = (props: DatasetDesignerWrapperProps) => {
  const { setDatasetConfig, datasetDesignerFormData, setDatasetDesignerFormData } = props
  const [, setIsMedusaRequestBodyValid] = useState(false)

  const baseUrl: string = window._env_.MEDUSA_URL

  const onDatasetDesignerFormChange = useCallback(() => {
    const dataset: Dataset = mapToDataset(datasetDesignerFormData)
    setDatasetConfig((prevConfig) => ({
      ...prevConfig,
      dataset: dataset,
    }))
  }, [datasetDesignerFormData, setDatasetConfig])

  const onSuccessfulMedusaRequest = (): void => setIsMedusaRequestBodyValid(true)
  const onFailedMedusaRequest = (): void => setIsMedusaRequestBodyValid(false)
  const handleSetDatasetDesignerFormData = (formData: FormDataset) =>
    setDatasetDesignerFormData(formData)

  return (
    <DatasetDesigner
      medusaBaseUrl={baseUrl}
      onSuccessfulMedusaRequest={onSuccessfulMedusaRequest}
      onFailedMedusaRequest={onFailedMedusaRequest}
      datasetDesignerFormData={datasetDesignerFormData}
      handleSetDatasetDesignerFormData={handleSetDatasetDesignerFormData}
      onFormChange={onDatasetDesignerFormChange}
    />
  )
}
export default DatasetDesignerWrapper
